import { Tabs, Tab } from 'braid-design-system';
import { Fragment } from 'react';

import type { DashboardTab } from 'src/views/Dashboard/types';

const navTab = (label: string, id: DashboardTab) => (
  <Tab
    data={{ htag: id, testid: `dashboard-navigation-tab-button-${id}` }}
    item={id}
  >
    {label}
  </Tab>
);

interface NavigationProps {
  paid: boolean;
}

const Navigation = ({ paid }: NavigationProps) => (
  <Tabs label="navTabs">
    {navTab('My ads', 'listings')}
    {navTab('My tools', 'tools')}
    {!paid ? navTab('Ad packs', 'products') : <Fragment />}
  </Tabs>
);

export default Navigation;
